import PastScholarshipWinnersList from './PastScholarshipWinnersList';

export default PastScholarshipWinnersList;
